import {
  DialogContent as MuiDialogContent,
  DialogContentProps as MuiDialogContentProps,
} from '@mui/material';
import { Theme, css } from '@emotion/react';

const dialogContentRoot = ({ colors, spacing }: Theme) => css`
  padding: ${spacing(3)};
  .MuiDialogContent-dividers {
    border-color: ${colors.borderLight};
  }
`;

export type DialogContentProps = MuiDialogContentProps;

/**
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const DialogContent = (props: DialogContentProps) => {
  return <MuiDialogContent dividers css={dialogContentRoot} {...props} />;
};

export default DialogContent;
